import $ from 'jquery';
import ClipboardJS from "clipboard/dist/clipboard.min.js"
window.ClipboardJS = ClipboardJS;
$(function () {
  var clipboard = new ClipboardJS('[data-clipboard-text]:not(.clipboard-initialised)');
  // setTimeout( () => {$('[data-clipboard-text]:not(.clipboard-initialised)').addClass('clipboard-initialised');}, 100);
  if (typeof(bootstrap_version) !== 'undefined' && bootstrap_version == 5){
    $('[data-clipboard-text][data-css-tooltip]').on('mouseleave', function () {
      var $el = $(this);
      var tooltip = bootstrap.Tooltip.getOrCreateInstance($(this));
      console.log('mouseleave', tooltip);

      // if (bootstrap.Tooltip.getInstance($(this))) tooltip.hide();
      // setTimeout(function () {
      //   console.log(bootstrap.Tooltip.getInstance($el));
      //   if (bootstrap.Tooltip.getInstance($el)) tooltip.dispose();
      // }, 150);
    });
  }
  clipboard.on('success', function(e) {
    // console.info('Action:', e.action);
    // console.info('Text:', e.text);
    // console.info('Trigger:', e.trigger);
    // console.log($(e.trigger).attr('data-css-tooltip'));
    if (e.text && e.text.length > 0) {
      if ($(e.trigger).attr('data-css-tooltip')) {
        $(e.trigger).attr('title', 'Copied!').addClass('css-tooltip-disabled');
        var tooltip = new bootstrap.Tooltip(e.trigger);
        tooltip.show();
        // setTimeout( function () {
        //   if (bootstrap.Tooltip.getInstance(e.trigger)) tooltip.dispose();
        // }, 800);
      }
    }
  });
  clipboard.on('error', function(e) {
    console.error('Action:', e.action);
    console.error('Trigger:', e.trigger);
  });
});
